var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12.8",
    width: 16,
    height: 12.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.4C0 10.387 1.613 12 3.6 12H12.8a3.2 3.2 0 0 0 0.64 -6.335 2.401 2.401 0 0 0 -3.573 -2.86A4 4 0 0 0 6.4 0.8a4 4 0 0 0 -3.995 4.202A3.6 3.6 0 0 0 0 8.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.6b011905e9c7d6d8bc12aa73d1696efb.svg";
export { ForwardRef as ReactComponent };